import { Injectable } from "@angular/core";
import { MockupHttpInterceptor } from "@vattenfall/core";

import { FlowsMoveAlongPrivateFinlandModel } from "./flows-move-along-private-finland.model";
const data: Array<FlowsMoveAlongPrivateFinlandModel> = [
  {
    firstName: "Tove",
    lastName: "Johansson",
    socialSecurityNumber: "210450-811U",
    emailAddress: "lillaMy@moomindalen.com",
    phoneNumber: "020976-0891",
    moveInDetails: {
      streetName: "Moominstreet 10",
      postalCode: "15800",
      postalTown: "Moomindalen",
      date: "2023-08-26",
    },
    moveOutDetails: {
      streetName: "Hätilänkatu 10",
      postalCode: "19430",
      postalTown: "Pertunmaa",
      date: "2023-08-29",
    },
  },
];
@Injectable()
export class FlowsMoveAlongPrivateFinlandServiceMockup extends MockupHttpInterceptor<FlowsMoveAlongPrivateFinlandModel> {
  constructor() {
    super({
      pathMatcher: "/api/move-along/orders",
      delay: 500,
      data,
    });
  }
}
